<div class="app-integration-account-form">
  <h2 mat-dialog-title>
    {{ mode === 'create' ? 'New' : 'Edit' }} Integration Account
    <button mat-dialog-close aria-label="Close dialog" class="close-button">
      <mat-icon>close</mat-icon>
    </button>
  </h2>

  <mat-dialog-content>
    <form [formGroup]="form">
      <div class="form-group">
        <label for="">App Type</label>
        <select
          *ngIf="!loadingRules; else inputLoader"
          (change)="onSelectAppType($event)"
          name=""
          id=""
          class="lum-input"
          formControlName="app"
        >
          <option *ngFor="let app of apps; trackBy: trackByValue" [value]="app">
            {{ app }}
          </option>
        </select>

        <mat-error *ngIf="form.get('app')?.touched && form.get('app')?.invalid">
          <small> This field is required </small>
        </mat-error>
      </div>

      <div class="form-group">
        <label for="">Label</label>
        <input
          type="text"
          class="text lum-input"
          formControlName="label"
          noEmptySpacesOnly
        />
        <mat-error *ngIf="form.get('label')?.touched && form.get('label')?.invalid">
          <small> This field is required </small>
        </mat-error>
      </div>

      <ng-container *ngIf="dynamicCredentialsFormControls?.length">
        <hr />
        <legend><b>Credentials</b></legend>

        <div formGroupName="credentials">
          <div
            *ngFor="let controlName of dynamicCredentialsFormControls"
            class="form-group"
          >
            <ng-container [ngSwitch]="fieldMetadata[controlName]?.type">
              <ng-container *ngSwitchCase="'INPUT_TEXT'">
                <label [for]="controlName">{{
                  fieldMetadata[controlName]?.label
                }}</label>
                <input
                  type="text"
                  [formControlName]="controlName"
                  class="lum-input"
                  [readonly]="isReadOnly(controlName, 'credentials')"
                />
              </ng-container>

              <ng-container *ngSwitchCase="'INPUT_NUMBER'">
                <label [for]="controlName">{{
                  fieldMetadata[controlName]?.label
                }}</label>
                <input
                  type="number"
                  [formControlName]="controlName"
                  class="lum-input"
                />
              </ng-container>

              <ng-container *ngSwitchCase="'TEXTAREA'">
                <label [for]="controlName">{{
                  fieldMetadata[controlName]?.label
                }}</label>
                <textarea
                  [formControlName]="controlName"
                  class="lum-input"
                ></textarea>
              </ng-container>

              <ng-container *ngSwitchCase="'SELECT'">
                <label [for]="controlName">{{
                  fieldMetadata[controlName]?.label
                }}</label
                ><select [formControlName]="controlName" class="lum-input">
                  <option
                    *ngFor="let option of fieldMetadata[controlName]?.values"
                    [value]="option"
                  >
                    {{ option }}
                  </option>
                </select></ng-container
              >

              <ng-container *ngSwitchCase="'CHECKBOX'">
                <mat-checkbox
                  [formControlName]="controlName"
                  class="example-margin"
                  >{{ fieldMetadata[controlName]?.label }}</mat-checkbox
                >
              </ng-container>

              <div *ngSwitchCase="'RADIO'" class="radio-group">
                <label *ngFor="let option of fieldMetadata[controlName]?.values">
                  <input
                    type="radio"
                    [value]="option"
                    [formControlName]="controlName"
                  />{{ option }}
                </label>
              </div>
              <input
                *ngSwitchDefault
                type="text"
                [formControlName]="controlName"
                class="lum-input"
              />
            </ng-container>

            <mat-error
              *ngIf="
                form.get(['credentials', controlName])?.touched &&
                form.get(['credentials', controlName])?.hasError('required')
              "
            >
              <small>This field is required</small>
            </mat-error>
          </div>
        </div>
      </ng-container>

      <ng-container *ngIf="dynamicSettingsFormControls?.length">
        <hr />
        <legend><b>Settings</b></legend>

        <div formGroupName="settings">
          <div
            *ngFor="let controlName of dynamicSettingsFormControls"
            class="form-group"
          >
            <ng-container [ngSwitch]="fieldMetadata[controlName]?.type">
              <ng-container *ngSwitchCase="'INPUT_TEXT'">
                <label [for]="controlName">{{
                  fieldMetadata[controlName]?.label
                }}</label>
                <input
                  type="text"
                  [formControlName]="controlName"
                  class="lum-input"
                  [readonly]="isReadOnly(controlName, 'settings')"
                />
              </ng-container>

              <ng-container *ngSwitchCase="'INPUT_NUMBER'">
                <label [for]="controlName">{{
                  fieldMetadata[controlName]?.label
                }}</label>
                <input
                  type="number"
                  [formControlName]="controlName"
                  class="lum-input"
                />
              </ng-container>

              <ng-container *ngSwitchCase="'TEXTAREA'">
                <label [for]="controlName">{{
                  fieldMetadata[controlName]?.label
                }}</label>
                <textarea
                  [formControlName]="controlName"
                  class="lum-input"
                ></textarea>
              </ng-container>

              <ng-container *ngSwitchCase="'SELECT'">
                <label [for]="controlName">{{
                  fieldMetadata[controlName]?.label
                }}</label
                ><select [formControlName]="controlName" class="lum-input">
                  <option
                    *ngFor="let option of fieldMetadata[controlName]?.values"
                    [value]="option"
                  >
                    {{ option }}
                  </option>
                </select></ng-container
              >

              <ng-container *ngSwitchCase="'CHECKBOX'">
                <mat-checkbox
                  [formControlName]="controlName"
                  class="example-margin"
                  >{{ fieldMetadata[controlName]?.label }}</mat-checkbox
                >
              </ng-container>

              <div *ngSwitchCase="'RADIO'" class="radio-group">
                <label *ngFor="let option of fieldMetadata[controlName]?.values">
                  <input
                    type="radio"
                    [value]="option"
                    [formControlName]="controlName"
                  />{{ option }}
                </label>
              </div>
              <input
                *ngSwitchDefault
                type="text"
                [formControlName]="controlName"
                class="lum-input"
              />
            </ng-container>

            <mat-error
              *ngIf="
                form.get(['settings', controlName])?.touched &&
                form.get(['settings', controlName])?.hasError('required')
              "
            >
              <small>This field is required</small>
            </mat-error>
          </div>
        </div>
      </ng-container>
    </form>
    <div></div>
  </mat-dialog-content>

  <mat-dialog-actions align="end">

    <lum-hubspot-connect-button
      *ngIf="appControlValue === 'hubspot'"
      class="mr-2"
      [config]="hubspotConfig"
      [disabled]="form.invalid"
    ></lum-hubspot-connect-button>

    <ng-container *ngIf="getActionKeys(currentActions)?.length; else actionDefault">
      <ng-container *ngFor="let actionKey of getActionKeys(currentActions)">
        <!-- TODO: Trackstar-specific "Connect WMS" button - Make this dynamic implementation -->
        <lum-trackstar-connect-wms-button
          *ngIf="actionKey === 'connectWms' && selectedApp === 'trackstar'"
          class="mr-2"
          [config]="trackstarConfig"
          [scriptUrl]="currentRule?.scriptUrl"
          [disabled]="loadingTrackstarEnvironment"
        ></lum-trackstar-connect-wms-button>

        <!-- Special handling for Faire "Authorize with Faire" button -->
        <button
          *ngIf="actionKey === 'authorize' && selectedApp === 'faire'"
          class="lum-button lum-button--primary mr-2"
          [disabled]="form.invalid || currentActions[actionKey].loading"
          (click)="handleActionClick(currentActions[actionKey], actionKey)"
        >
          {{ currentActions[actionKey].label }}
          <mat-spinner
            *ngIf="currentActions[actionKey].loading"
            class="ml-2"
            [diameter]="16"
          ></mat-spinner>
        </button>
        <!-- Regular buttons for other actions or apps -->
        <button
          *ngIf="!(actionKey === 'authorize' && selectedApp === 'faire') &&
             !(actionKey === 'connectWms' && selectedApp === 'trackstar')"
          class="lum-button mr-2"
          [ngClass]="{
            'lum-button--secondary': actionKey === 'testCredentials',
            'lum-button--primary':
              actionKey === 'save' || actionKey === 'authorize',
          }"
          [disabled]="form.invalid || currentActions[actionKey].loading"
          (click)="handleActionClick(currentActions[actionKey], actionKey)"
        >
          {{ currentActions[actionKey].label }}
          <mat-spinner
            *ngIf="currentActions[actionKey].loading"
            class="ml-2"
            [diameter]="16"
          ></mat-spinner>
        </button>
      </ng-container>
    </ng-container>

    <ng-template #actionDefault>
      <button class="lum-button" [disabled]="true">Save</button>
    </ng-template>
  </mat-dialog-actions>
</div>

<ng-template #inputLoader>
  <div class="lum-input">
    <mat-spinner class="ml-auto" [diameter]="16"></mat-spinner>
  </div>
</ng-template>
